import React from 'react'
import Avatar from '@material-ui/core/Avatar'
import { v4 as uuid } from 'uuid'
import { Button, Snackbar } from '@material-ui/core'
import MuiAlert from '@material-ui/lab/Alert'
import { AlertTitle } from '@material-ui/lab'
import EditIcon from '@material-ui/icons/Edit'
import clsx from 'clsx'
import { Link } from 'react-router-dom'
import CancelOutlinedIcon from '@material-ui/icons/CancelOutlined'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogContentText from '@material-ui/core/DialogContentText'
import DialogTitle from '@material-ui/core/DialogTitle'
import FlashMassage from 'react-flash-message'
import { StyledOnlineBadge, StyledOfflineBadge } from '../../../styles'

export const UserIcon = ({
  profileImage,
  profileWebpImage,
  online,
  userName,
  rootIcon,
  editProfile,
  onlineBadge,
  offlineBadge,
  userNameClass,
  fullName
}) => {
  const [open, setOpen] = React.useState(false)
  const [state, setState] = React.useState({ code: '' })

  function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />
  }

  const handleClickOpen = () => {
    setOpen(true)
  }

  const handleClose = () => {
    setOpen(false)
  }

  const handleSubmit = (e) => {
    e.preventDefault()

    const token = localStorage['BUND-X-AUTH-TOKEN']
    const _data = {
      username: userName
    }
    const headers = {
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest',
      Authorization: `Bearer ${token}`
    }
    const requestOptions = {
      method: 'DELETE',
      headers: headers,
      body: JSON.stringify(_data)
    }
    fetch(`/api/v1/user/delete/${userName}`, requestOptions).then((r) =>
      r.json(setState({ code: r.status })).then((result) => {
        if (state.code === 200) {
          console.log('====================================')
          console.log(result)
          console.log('====================================')
        } else if (state.code === 202) {
          console.log('====================================')
          console.log(result)
          console.log('====================================')
        }
        console.log('====================================')
        console.log(result.errors, result.message)
        console.log('====================================')
      })
    )
    // window.location.reload()
    setTimeout(location.reload.bind(location), 8000)
  }

  if (online === true) {
    return (
      <div className={rootIcon} style={{ display: 'grid' }}>
        {state.code === 200 && (
          <FlashMassage duration={8000}>
            <Snackbar open autoHideDuration={8000}>
              <Alert severity="success">
                <AlertTitle>Success</AlertTitle>
                User <strong>@{userName}</strong> have been deleted
                successfully.
              </Alert>
            </Snackbar>
          </FlashMassage>
        )}
        {profileWebpImage === undefined ? null : (
          <div>
            <Link to={`/admin/user/@${userName}`}>
              <StyledOnlineBadge
                overlap="circular"
                anchorOrigin={{
                  vertical: 'bottom',
                  horizontal: 'right'
                }}
                variant="dot"
                className={onlineBadge}>
                <Avatar
                  key={uuid()}
                  alt={profileWebpImage}
                  imgProps={{
                    style: {
                      width: '512px',
                      height: '100%'
                    }
                  }}
                  src={'/imgs/staff/' + profileWebpImage}
                />
              </StyledOnlineBadge>
              <div className={clsx(userNameClass, 'text-color')}>
                {fullName}
              </div>
            </Link>
            <Button
              size="small"
              style={{
                padding: '0 !important',
                margin: 0,
                minWidth: 0,
                border: 'none'
              }}
              className={clsx(editProfile, 'link-style')}
              startIcon={
                <EditIcon style={{ padding: 0, margin: 0 }} fontSize="small" />
              }
              variant="outlined">
              <Link
                aria-label="edit-online-user"
                className="link-style"
                to={`/admin/user/@${userName}/edit`}>
                Edit
              </Link>
            </Button>
            {/* <form action={'../delete/this/child/process/'} method="POST"> */}
            <Button
              className="link-style"
              onClick={handleClickOpen}
              aria-label="edit-online-user-data"
              style={{
                minWidth: 'fit-content',
                float: 'right',
                // marginTop: '-25px',
                marginRight: 0,
                top: '-21px',
                right: '-75px',
                outline: 'none',
                padding: 0
              }}>
              <CancelOutlinedIcon
                style={{
                  fontSize: 'small',
                  color: 'red'
                }}
              />
            </Button>
            <Dialog
              open={open}
              onClose={handleClose}
              aria-labelledby="online-user-delete-alert"
              className="text-color"
              aria-describedby="online-user-delete-alert-dialog">
              <DialogTitle
                className="text-color card-body-color"
                id="online-user-delete-alert">
                {'Are you sure?'}
              </DialogTitle>
              <DialogContent className="text-color card-body-color">
                <DialogContentText
                  className="text-color card-body-color"
                  id="online-user-delete-alert-dialog">
                  This action connot be undone, are you sure you want to delete
                  this user ?
                </DialogContentText>
              </DialogContent>
              <DialogActions className="text-color card-body-color">
                <Button
                  style={{ outline: 'none', color: 'currentColor' }}
                  className="text-color card-body-color"
                  aria-label="cancel-online-user-delete"
                  onClick={handleClose}>
                  Cancel
                </Button>
                <form onSubmit={handleSubmit} noValidate>
                  <Button
                    style={{ outline: 'none', color: 'red' }}
                    className="text-color card-body-color"
                    type="submit"
                    aria-label="confirm-online-user-delete"
                    onClick={handleClose}
                    autoFocus>
                    Delete
                  </Button>
                </form>
              </DialogActions>
            </Dialog>
            {/* </form> */}
          </div>
        )}
      </div>
    )
  } else {
    return (
      <div className={rootIcon} style={{ display: 'grid' }}>
        {state.code === 200 && (
          <FlashMassage duration={8000}>
            <Snackbar open autoHideDuration={8000}>
              <Alert severity="success">
                <AlertTitle>Success</AlertTitle>
                User <strong>@{userName}</strong> have been deleted
                successfully.
              </Alert>
            </Snackbar>
          </FlashMassage>
        )}
        {profileWebpImage === undefined ? null : (
          <div>
            <StyledOfflineBadge
              overlap="circular"
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'right'
              }}
              variant="dot"
              className={offlineBadge}>
              <Avatar
                key={uuid()}
                alt={profileWebpImage}
                imgProps={{
                  style: {
                    width: '512px',
                    height: '100%'
                  }
                }}
                src={'/imgs/staff/' + profileWebpImage}
              />
            </StyledOfflineBadge>
            <div className={clsx(userNameClass, 'text-color')}>{fullName}</div>
            <Button
              size="small"
              aria-label="edit-offline-user-data"
              style={{
                padding: '0 !important',
                margin: 0,
                minWidth: 0,
                border: 'none'
              }}
              className={clsx(editProfile, 'link-style')}
              startIcon={
                <EditIcon style={{ padding: 0, margin: 0 }} fontSize="small" />
              }
              variant="outlined">
              <Link
                aria-label="edit-offline-user"
                className="link-style"
                to={`/admin/user/@${userName}/edit`}>
                Edit
              </Link>
            </Button>
            <Button
              className="link-style"
              onClick={handleClickOpen}
              aria-label="user-delete"
              style={{
                minWidth: 'fit-content',
                float: 'right',
                // marginTop: '-25px',
                marginRight: 0,
                top: '-21px',
                right: '-75px',
                outline: 'none',
                padding: 0
              }}>
              <CancelOutlinedIcon
                style={{
                  fontSize: 'small',
                  color: 'red'
                }}
              />
            </Button>
            <Dialog
              open={open}
              onClose={handleClose}
              aria-labelledby="offline-user-delete-alert"
              className="text-color"
              aria-describedby="offline-user-delete-alert-dialog-description">
              <DialogTitle
                className="text-color card-body-color"
                id="offline-user-delete-alert">
                {'Are you sure?'}
              </DialogTitle>
              <DialogContent className="text-color card-body-color">
                <DialogContentText
                  className="text-color card-body-color"
                  id="offline-user-delete-alert-dialog-description">
                  This action connot be undone, are you sure you want to delete
                  this user ?
                </DialogContentText>
              </DialogContent>
              <DialogActions className="text-color card-body-color">
                <Button
                  style={{ outline: 'none', color: 'currentColor' }}
                  onClick={handleClose}
                  aria-label="cancel-offline-user-delete"
                  className="text-color card-body-color">
                  Cancel
                </Button>
                <form onSubmit={handleSubmit} noValidate>
                  <Button
                    style={{ outline: 'none', color: 'red' }}
                    className="text-color card-body-color"
                    aria-label="confirm-offline-user-delete"
                    type="submit"
                    onClick={handleClose}
                    autoFocus>
                    Delete
                  </Button>
                </form>
              </DialogActions>
            </Dialog>
          </div>
        )}
      </div>
    )
  }
}

UserIcon.displayName = 'ui'

export default UserIcon
